import styles from './GalleryItem.module.css';
import Handle from '../../../public/images/icons/gallery_handle.svg';
import Close from '../../../public/images/icons/close.svg';
import { UploadPreview } from '../Preview/UploadPreview';
import { UploadItem, UploadItemStatus } from '../../UploadDropzone/uploadManager';
import { ProgressBar } from '../../ProgressBar/ProgressBar';
import { useEffect, useState } from 'react';
import { Spinner } from '../../Spinner/Spinner';

export interface GalleryItemProps {
    id: string;
    cover: string;
    coverType: 'video' | 'photo';
    name: string;
    onRemove: () => void;
    uploadItem?: UploadItem;
}
export const GalleryItem = ({ cover, coverType, name, uploadItem, onRemove }: GalleryItemProps) => {
    const [ progress, setProgress ] = useState(uploadItem?.progress?.progress || 0);
    const [ status, setStatus ] = useState<UploadItemStatus | undefined>(uploadItem?.status);

    const onUploadUpdated = () => {
        setProgress(uploadItem?.progress?.progress || 0);
        setStatus(uploadItem?.status);
    }


    useEffect(() => {

        if (uploadItem) {
            uploadItem.uploadUpdated.on(onUploadUpdated);
        }

        return () => {
            uploadItem?.uploadUpdated.off(onUploadUpdated);
        }
    }, [uploadItem]);

    let progressText;
    let showSpinner = false;

    switch (status) {
        case 'complete':
            progressText = "Complete";
            break;
        case 'waiting':
            progressText = "Waiting";
            break;
        case 'error':
            progressText= "Error";
            break;
        case 'uploading':
            progressText = `Uploading ${(progress * 100).toFixed(0)}%`;
            showSpinner = true;
            break;
        case 'hashing':
            progressText = "Getting Ready...";
            showSpinner = true;
            break;
    }

    return (
        <div className={styles.gallery_item}>
            <div className='flex items-center'>
                <Handle className="h-8 w-8 flex-none text-secondary upload-handle" />
                <div className={styles.gallery_item_image}>
                    <UploadPreview className="w-full h-full" coverType={coverType} cover={cover} />
                </div>

                <div className={styles.gallery_item_text}>{name}
                </div>
                <Close onClick={onRemove} className="h-8 w-8 flex-none text-secondary cursor-pointer" />
            </div>
            <div>
                {uploadItem &&
                <>
                    {/* <ProgressBar className='h-[24px] m-1' progress={status === 'complete' ? 100 : progress * 100}>
                        <div className="flex items-center justify-center gap-x-2 h-full w-full">
                            {showSpinner && <Spinner className="h-4 w-4" />}
                            {progressText}
                        </div>
                    </ProgressBar> */}
                </>
                }

            </div>
            
        </div>
    )
}